import * as React from 'react';

function SvgFavorite(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20 8.623c0 4.15-2.915 8.04-8 11.377-5.085-3.338-8-7.226-8-11.377 0-.422.03-.724.09-.929C4.503 5.586 6.296 4 8.444 4 9.898 4 11.19 4.726 12 5.849 12.81 4.726 14.102 4 15.556 4c2.148 0 3.94 1.586 4.354 3.694.06.205.09.507.09.93z"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default SvgFavorite;
